"use client";

import React, { useState } from "react";
import GymTopBar from "@/components/demos/gym/GymTopBar";

export default function GymDemoClientLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const [currency, setCurrency] = useState<"INR" | "USD">("INR");

  return (
    <div className="min-h-screen bg-stone-950 text-stone-100 flex flex-col font-sans">
      <GymTopBar currency={currency} onCurrencyChange={setCurrency} />
      <main className="flex-1">
        {React.isValidElement(children)
          ? React.cloneElement(children as React.ReactElement<any>, { currency })
          : children}
      </main>
    </div>
  );
}
